export default {
  timeRange: {
    ONE_DAY: '1 NGÀY',
    FIVE_DAYS: '5 NGÀY',
    TEN_DAYS: '10 NGÀY',
    ONE_MONTH: '1 THÁNG',
  },

  LABEL_CHART_TOOLTIP_AVG: {
    ONE_DAY: 'Tổng Giá Trị Giao Dịch Hôm Qua: ',
    OTHERS: 'Giá Trị Giao Dịch Trung Bình %{timeRange}: ',
  },
  LABEL_CHART_TOOLTIP_TODAY: 'Tổng GTGD Hôm Nay: ',
  LABEL_CHART_LEFT: 'GTGD (Tỷ)',
  LABEL_CHART_BOTTOM_TODAY: 'Tổng GTGD Hôm Nay',
  LABEL_CHART_BOTTOM_AVG: {
    OneDay: 'Tổng GTGD Hôm Qua',
    OneWeek: 'GTGDTB 5 Ngày',
    TwoWeeks: 'GTGDTB 10 Ngày',
    OneMonth: 'GTGDTB 1 Tháng',
  },
  busdTitle: 'Biểu đồ Mua/Bán Chủ Động',
  footerNote: 'Khối lượng: x 1000, Giá: x1000',
  footerNoteIndex: 'Khối lượng: x 1000',
};
